import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { VueTelInput } from "vue-tel-input";
// import "vue-tel-input/dist/vue-tel-input.css";

export default /*#__PURE__*/_defineComponent({
  __name: 'phoneInput',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueTelInput), _mergeProps(_ctx.$attrs, {
    mode: "international",
    enabledCountryCode: "",
    validCharactersOnly: "",
    inputOptions: { placeholder: _ctx.$t('phoneNumber'), showDialCode: true },
    class: "phone-input"
  }), null, 16, ["inputOptions"]))
}
}

})